module.exports = __webpack_public_path__ + "static/img/day.8a96d981.png";